import * as URI from 'urijs';
import { MediaDocument } from '../../media-document.model';
import { ICON_TVEYES_URL } from '../content-document-adapter.config';

const extractAuthors = (document: any) => {
    const authors = document.authors;
    if (!authors) {
        return authors
    }

    const filteredAuthors = authors.filter( a => getAuthorName(a, document.sourceId));
    return filteredAuthors.map(a => {
        return {
            icmUrl: a.id ? `/icm-web/influencers/contact/view/${a.id}` : null,
            name: getAuthorName(a, document.sourceId),
        }
    });
}

const getAuthorName = (author: any, sourceId: string = null) => {
    if (author.authorInfo && author.authorInfo.structuredName && author.authorInfo.structuredName.firstName && author.authorInfo.structuredName.lastName) {
        const { prefix, firstName, middleName, lastName, suffix } = author.authorInfo.structuredName;
        return [prefix, firstName, middleName, lastName, suffix].filter(p => !!p).join(' ');
    } else if (sourceId && sourceId.indexOf('adhoc:') > -1 && (!author.authorInfo || !author.authorInfo.structuredName) && author.name) {
        return author.name;
    }
}

export class ContentDocumentTveyesAdapter {
    static toContentDocument(document: any): MediaDocument {
        let contentDocument = new MediaDocument(document);

        contentDocument.documentId = document.documentId;
        contentDocument.isHosted = document.isHosted;
        contentDocument.authors = extractAuthors(document);
        contentDocument.date = document.date;
        contentDocument.dupDocs = [];
        contentDocument.dupDocsCount = document.dupDocsCount;
        contentDocument.dupDocsIdsRemaining = document.remainingDupDocsIds;
        // contentDocument.ingress = getOpeningText(document); //TODO: not sure if we need this
        contentDocument.keywords = document.keywords;
        contentDocument.matchSentences = [document.matchSentence || document.tagContextMatchSentence];
        contentDocument.mediaType = document.mediaType;
        contentDocument.mediaTypeIcon = document.mediaTypeIcon || contentDocument.mediaType;
        contentDocument.provider = document.provider;
        contentDocument.sentiment = document.isSentimentModified ? document.originalSentiment : document.sentiment;
        contentDocument.sentimentOverride = document.isSentimentModified ? document.sentiment : '';
        contentDocument.sourceAvatarImgUrl = document.sourceId ? `${ICON_TVEYES_URL}/icons/${document.sourceId}` : '';
        contentDocument.sourceAvatarLinkUrl = document.paywallUrl || document.redirectUrl || document.url || document.sourceUrl;
        contentDocument.sourceCountryCode = document.country || document.countryCode;
        contentDocument.sourceName = document.source || 'Unknown';
        contentDocument.sourceNameUrl = document.sourceUrl || document.url;
        contentDocument.tags = document.tags;
        contentDocument.title = document.title;
        contentDocument.titleUrl = document.paywallUrl || document.redirectUrl || document.url || document.sourceUrl;
        contentDocument.language = document.language;

        // TODO: not sure if we need this, might be same as sourceUrl
        contentDocument.url = document.paywallUrl || document.redirectUrl || document.url || document.sourceUrl;

        // TODO: not sure if we should bake in support for these but putting them in for now
        contentDocument.reachCount = document.reach;
        contentDocument.potentialReach = document.potentialReach;

        return contentDocument;
    }
}

// TODO: not sure if we need this
function getOpeningText(document) {
    let openingText = document.ingress;

    if (document.sourceId && document.sourceId.indexOf('adhoc:') > -1) {
        let ingress = document.ingress;
        if (ingress) {
            if (ingress.indexOf('...', ingress.length - 3) > -1) {
                ingress = ingress.slice(0, ingress.length - 3);
            }

            // so the openingText is the ingress as long as the matchsentence does not contain
            // the ingress (minus some ellipsis)
            if (document.matchSentence.indexOf(ingress) === -1 ) {
                openingText = ingress;
            }
        }
    }

    return openingText;
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/adapters/content-document-tveyes.adapter.ts